/**
 * @description: 用户权限获取
 * @author: Adrian
 */
const TokenKey = 'AUTH-TOKEN'
import store from '@/store';
import Cookies from 'js-cookie';


export function getToken() {
  // return window.sessionStorage.getItem(TokenKey)
  return Cookies.get(TokenKey);

}

export function setToken(token) {
  // window.sessionStorage.setItem(TokenKey, token)
  return Cookies.set(TokenKey, token);

}

export function removeToken() {
  // window.sessionStorage.removeItem(TokenKey)
  store.commit("setToken", false);
  // 如何删除浏览器中的 会话存储空间中的 dataStore
  window.sessionStorage.removeItem('dataStore');
  return Cookies.remove(TokenKey);
}

export function logout() {
  store.commit("setToken", false);
  return Cookies.remove(TokenKey);
}
